import gql from 'graphql-tag';

import { TAP_FIELDS } from '../../data/graphql';

export const CREATE_TAP = gql`
    mutation($tap: CreateOneTapInput!){
        tapCreateOne(record:$tap){
            record {
                ${TAP_FIELDS}
            }
        }
    }

`;
export const UPDATE_TAP = gql`
    mutation($tap: UpdateByIdTapInput!){
        tapUpdateById(record:$tap){
            record {
                ${TAP_FIELDS}
            }
        }
    }
`;

export const DELETE_TAP = gql`
    mutation($id:MongoID!){
        tapRemoveById(_id:$id){
            record {
                ${TAP_FIELDS}
            }
        }
    }
`;

export const SIGN_FILE_FOR_UPLOAD = gql`
  mutation ($locationName: String!, $fileName: String!, $fileType: String!) {
    signFile(location_name: $locationName, file_name: $fileName, file_type: $fileType) {
      signedUrl
      resourceUrl
    }
  }
`;
